import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import { Tabs } from 'antd-mobile-v5';
import QueueQR from './queueQR';
import AddPatientDetail from './addPatientManually';

const AddPatient = (props: any) => {

    const [activeKey, setActiveKey] = useState('scanCode');

    useEffect(() => {
    }, [])

    const tabsChange = (value: any) => {
        setActiveKey(value);
    }

    return (
        <div className={`${styles.addPatient_content}`}>
            <Tabs
                className={styles.outer_form_tab}
                activeKey={activeKey}
                onChange={(value) => { tabsChange(value) }}
                activeLineMode='fixed'
                style={{
                    '--fixed-active-line-width': '35px',
                    '--content-padding': '0',
                }}
            >
                <Tabs.Tab title='患者扫码添加' key='scanCode'>
                    <div>
                        <QueueQR {...props} />
                    </div>
                </Tabs.Tab>
                <Tabs.Tab title='手动建档添加' key='byHand'>
                    <AddPatientDetail {...props} />
                </Tabs.Tab>
            </Tabs>
        </div>
    )
}

export default AddPatient;